"use client"

import { Card } from "@/components/ui/card"
import { useSourceStore } from "@/lib/source-store"
import { useResponsiveGridColumns } from "@/hooks/use-responsive-grid-columns"
import { useSettingsStore } from "@/lib/settings-store"
import { cn } from "@/lib/utils"

interface BoardCardsProps {
  onBoardClick: (boardId: string, boardName: string) => void
  className?: string
}

export function BoardCards({ onBoardClick, className }: BoardCardsProps) {
  const { getSource } = useSourceStore()
  const { gridColumns } = useResponsiveGridColumns()
  const { gridGap, borderRadius } = useSettingsStore()
  
  const source = getSource("4chan")
  // Every board but the risky ones: the strip's board choice no longer decides which cards exist (it starts as none).
  const boardDetails = (source?.boards?.available || [])
    .filter((board) => !board.risky)
    .map((board) => ({ id: board.id, name: board.name, description: board.description || "" }))

  const getGridColsClass = () => {
    return {
      gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`,
    }
  }

  return (
    <div
      className={cn("grid p-4", className)}
      style={{
        gap: `${gridGap}px`,
        ...getGridColsClass(),
      }}
    >
      {boardDetails.map((board) => (
        <Card
          key={board.id}
          className="cursor-pointer transition-all hover:scale-[1.02] hover:shadow-lg overflow-hidden"
          style={{ borderRadius: `${borderRadius}px` }}
          onClick={() => onBoardClick(board.id, board.name)}
        >
          <div className="aspect-square flex flex-col items-center justify-center p-6 bg-gradient-to-br from-green-500/10 to-green-600/20">
            <div className="text-4xl font-bold text-green-600 mb-2">
              /{board.id}/
            </div>
            <div className="text-sm font-medium text-center mb-1">
              {board.name}
            </div>
            {board.description && (
              <div className="text-xs text-muted-foreground text-center">
                {board.description}
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  )
}
